export const GROUPNAMES_TRANSLATE = {
  1: {
    tr: "Ametal",
    en: "Nonmetal",
  },
  2: {
    tr: "Alkali Metal",
    en: "Alkali Metal",
  },
  3: {
    tr: "Alkali Toprak Metal",
    en: "Alkaline Earth Metal",
  },
  4: {
    tr: "Geçiş Metali",
    en: "Transition Metal",
  },
  5: {
    tr: "Metal",
    en: "Post-Transition Metal",
  },
  6: {
    tr: "Yarı Metal",
    en: "Metalloid",
  },
  7: {
    tr: "Halojen",
    en: "Halogen",
  },
  8: {
    tr: "Soygaz",
    en: "Noble Gas",
  },
  9: {
    tr: "Lantanit",
    en: "Lanthanide",
  },
  10: {
    tr: "Aktinit",
    en: "	Actinide",
  },
};
